import { GenericCache } from './genericCache';

const ANNOUNCEMENTS_CACHE_KEY = 'dismissed_announcements_cache';
const ANNOUNCEMENTS_CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours

class AnnouncementsCache {
  private cache = new GenericCache<string[]>({
    key: ANNOUNCEMENTS_CACHE_KEY,
    duration: ANNOUNCEMENTS_CACHE_DURATION,
  });

  get(): string[] {
    return this.cache.get() ?? [];
  }

  add(id: string) {
    const ids = this.get();
    if (!ids.includes(id)) {
      this.cache.set([...ids, id]);
    }
  }

  setAll(ids: string[]) {
    this.cache.set(ids);
  }

  clear() {
    this.cache.clear();
  }
}

export const announcementsCache = new AnnouncementsCache();
